import React from 'react'

function Line() {
  return <div style={{ borderTop: '1px solid var(--color-secundary-04)' }} />
}

export default Line
